<div class="Modal">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons"> {{ data.icon }} </span>
      <p>{{ data.textIcon }}</p>
    </div>
    <span class="material-icons float-end CloseModal" mat-dialog-close>
      close
    </span>
  </div>

  <div
    class="mt-32 mb-32 align-items-center justify-content-center mr-32 ml-32"
  >
    <img
      src="{{ data.img }}"
      alt="{{ data.descriptionImg }}"
      style="height: 200px"
      class="img-fluid rounded"
      *ngIf="this.isImg"
    />
    <iframe
      [src]="this.pdf"
      style="height: 200px"
      *ngIf="!this.isImg"
      class="img-fluid rounded"
    ></iframe>
  </div>

  <div class="row">
    <div class="col text-center">
      <div class="mb-32">
        Confira seus documentos, se não estiver correto,<br />
        feche a janela e envie novamente.
      </div>
    </div>
  </div>
</div>
